import Button from "./Button";

export default function Offre({ pack, prix, presentation, TTC = false, APartir = false, children }) {
    return (

        <div className="offre-container">
            <div className="card-offre-container">
                <h4 className="f36 sansita">Pack {pack}</h4>
                <p className="offre-presentation f20">
                    {presentation}
                </p>
                <div className="btn-container">
                    <Button label='Choisir cette offre' color='white' tel/>
                </div>
                <div className="prix-container">
                    {APartir ? <p className="apartir">A partir de</p> : ''}
                    <p className="prix f48">{prix}</p>
                    {TTC ? <p className="TTC f16">TTC</p> : ''}
                </div>

                <ul>
                    {children}
                </ul>
            </div>
        </div>

    )
}